/****************************************************
 * Module Name:  addNivodaUserModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import NivodaUserProxy from "../../utility/proxy/nivodautility/nivodaUserProxy";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';

export default class AddNivodaUserModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newId: this.props.editOperation ? this.props.sourceData.id : null,
            newUser: this.props.editOperation ? this.props.sourceData.user : "",
            newUsername: this.props.editOperation ? this.props.sourceData.username : "",
            newPassword: this.props.editOperation ? atob(this.props.sourceData.password) : "",

            showError: false,
            validateNivodaUserPresentSpinner: false,
            showValidationMessage: false,
            nivodaUserAvailable: true,
            nivodaUserValidationError: "",
            usernameValidationError: "",
            passwordValidationError: "",
        };
    }

    handleSave = () => {
        let data = {
            id: this.state.newId,
            user: this.state.newUser,
            username: this.state.newUsername,
            password: btoa(this.state.newPassword)
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data))
                    this.props.handleSave(data);
                else
                    this.setState({ showError: true });
            } else
                this.props.handleSave(data);
        }
    };

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    validateNivodaUserPresent = (nivodaUserEntered) => {
        if (!nivodaUserEntered || nivodaUserEntered.trim() === "") return;

        this.setState({
            validateNivodaUserPresentSpinner: true,
        });

        NivodaUserProxy.CheckNivodaUserAvailable(nivodaUserEntered, (response) => {
            //if we got response that means nivodaUser is present at backend
            if (response) {
                //NivodaUserName already present
                this.setState({
                    validateNivodaUserPresentSpinner: false,
                    showValidationMessage: true,
                    nivodaUserAvailable: false,
                });
            } else {
                //NivodaUserName not available, so can be used
                this.setState({
                    validateNivodaUserPresentSpinner: false,
                    showValidationMessage: true,
                    nivodaUserAvailable: true,
                });
            }
        });
    };

    buttonDisable = () => {
        if (this.props.editOperation && (this.state.newUsername.length === 0 || this.state.newPassword.length === 0))
            return true;

        if (!this.props.editOperation)
            return (
                !this.state.showValidationMessage ||
                !this.state.nivodaUserAvailable ||
                this.state.newUsername.length === 0 ||
                this.state.newPassword.length === 0
            );

        return false;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add nivodaUser validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation ? "Edit Nivoda User" : "Add New Nivoda User"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                User <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        {this.props.editOperation ? (
                                            <td>
                                                <Form.Label>{this.state.newUser}</Form.Label>
                                            </td>
                                        ) : (
                                            <td>
                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    label="Nivoda User (required)"
                                                    placeholder="Enter Nivoda User"
                                                    value={this.state.newUser}
                                                    autoFocus
                                                    onBlur={(e) =>
                                                        this.validateNivodaUserPresent(this.state.newUser)
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            newUser: e.target.value,
                                                            showValidationMessage: false,
                                                            nivodaUserValidationError: Utility.CheckIsPresent(e.target.value) ? ""
                                                                : "Nivoda User Cannot be Empty",
                                                        })
                                                    }
                                                    helperText={this.state.nivodaUserValidationError}
                                                    error={this.state.nivodaUserValidationError.length > 0}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            {this.state.validateNivodaUserPresentSpinner ? (
                                                <CircularProgress size="1rem" />
                                            ) : !this.state.showValidationMessage ? (
                                                <Box>&nbsp;</Box>
                                            ) : this.state.nivodaUserAvailable ? (
                                                <font color="green">Nivoda User available</font>
                                            ) : (
                                                <font color="red">Nivoda User not available</font>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Username <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                label="Username (required)"
                                                placeholder="Enter Nivoda Username"
                                                value={this.state.newUsername}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newUsername: e.target.value,
                                                        usernameValidationError: Utility.CheckIsPresent(e.target.value)
                                                            ? ""
                                                            : "Nivoda Username Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.usernameValidationError}
                                                error={this.state.usernameValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Password <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                label="Password (required)"
                                                placeholder="Enter Password"
                                                value={this.state.newPassword}
                                                onChange={(e) =>
                                                    this.setState({
                                                        newPassword: e.target.value,
                                                        passwordValidationError: Utility.CheckIsPresent(e.target.value)
                                                            ? ""
                                                            : "Nivoda Password Cannot be Empty",
                                                    })
                                                }
                                                helperText={this.state.passwordValidationError}
                                                error={this.state.passwordValidationError.length > 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}
